import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/print.css";
import { registerServiceWorker } from "./lib/sw-register";
import { forceFreshIfStale } from "./lib/app-version";
import { installDemoEmbedGuards, isDemoEmbedContext } from "./lib/demo-embed-guard";

// Marketing live embed: neuter permission prompts BEFORE any app code runs.
installDemoEmbedGuards();

// Register the SW immediately and run the freshness check IN PARALLEL. The
// old code awaited the version.json fetch before registering — a network RTT
// serialized in front of SW startup on every launch. The SW update machinery
// (sw-register.ts) is the primary freshness path; forceFreshIfStale is its
// escalating backstop (surgical update → scorched earth only if a stale
// build persists across launches). The embed skips the SW entirely — it's a
// throwaway read-only session.
if (!isDemoEmbedContext()) {
    registerServiceWorker();
    void forceFreshIfStale();
}
createRoot(document.getElementById("root")!).render(<App />);
